import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { IEventLight } from '../../Models';
import { EventService } from '../../Services';
import { UniqueIdGenerator } from '../../Helpers/uniqueIdHelper';

interface IEventsByThemeProps {
    dictDontMissIt: string;
    broadcastId: number;
    eventsCount: number;
    eventDetailPageUrl: string;
}

interface IEventsByThemeWidgetState {
    events: IEventLight[];
    isLoading: boolean;
}

export class EventsByThemeWidget extends Component<
    IEventsByThemeProps,
    IEventsByThemeWidgetState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            events: [],
            isLoading: false,
        };
        void this.getAllEvent();
    }

    componentDidMount(): void {
        void this.getAllEvent();
    }

    async getAllEvent() {
        this.setState({ isLoading: true });
        try {
            const events = await EventService.getAll({
                broadcastChannelExternalIds: [this.props.broadcastId],
                categories: [],
                hashtags: [],
                count: this.props.eventsCount,
            });
            // remap events to have correct Date object inside
            const eventsWithDate = events.map((event) => ({
                category: event.category,
                dateEnd: event.dateEnd ? new Date(event.dateEnd) : undefined,
                dateStart: new Date(event.dateStart),
                dateEndString: event.dateEndString,
                dateStartString: event.dateStartString,
                description: event.description,
                reference: event.reference,
                title: event.title,
            }));

            this.setState({
                events: eventsWithDate,
                isLoading: false,
            });
        } catch (e) {
            if (!(e instanceof DOMException) || e.name !== 'AbortError') {
                throw e;
            }
        }
    }

    render() {
        return this.state.events && this.state.events.length > 0 ? (
            <div className="events-bloc row">
                <div className="col-12">
                    <h3 id="five">{this.props.dictDontMissIt}</h3>
                </div>
                {this.state.isLoading && (
                    <div className="lds-ripple">
                        <div></div>
                        <div></div>
                    </div>
                )}
                {!this.state.isLoading &&
                    this.state.events.map((e, index) => (
                        <a
                            href={`${this.props.eventDetailPageUrl}?reference=${e.reference}`}
                            key={UniqueIdGenerator.generateId(
                                `${e.title}`,
                                index
                            )}
                            className="event gtm-event col-12"
                        >
                            <div className="col-2 event--date">
                                {e.dateStartString === e.dateEndString ? (
                                    <span>{e.dateStartString}</span>
                                ) : (
                                    <>
                                        <span>{e.dateStartString}</span>
                                        <span className="dash">-</span>
                                        <span>{e.dateEndString}</span>
                                    </>
                                )}
                            </div>
                            <div className="col-10 event--content">
                                <div className="state font-weight-bold">
                                    {e.title}
                                </div>
                                {e.category && (
                                    <div className="event--content__title">
                                        {e.category}
                                    </div>
                                )}
                            </div>
                        </a>
                    ))}
            </div>
        ) : (
            <></>
        );
    }
}

WidgetHelper.register(EventsByThemeWidget, 'events-by-theme-widget');
